import { render, staticRenderFns } from "./category_edit.vue?vue&type=template&id=5a378d24&scoped=true"
import script from "./category_edit.vue?vue&type=script&lang=ts"
export * from "./category_edit.vue?vue&type=script&lang=ts"
import style0 from "./category_edit.vue?vue&type=style&index=0&id=5a378d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a378d24",
  null
  
)

export default component.exports